import { TimepointSubmissionStatus } from '@common/config/api/client'
import { ReactNode, useState } from 'react'
import { ExamReassignementContext, ExamReassignementContextType } from './ExamReassignementContext'

export const ExamReassignementProvider = ({ children }: { children: ReactNode }) => {
  const [sourceStatus, setSourceStatus] = useState<TimepointSubmissionStatus | null>(null)
  const [destinationStatus, setDestinationStatus] = useState<TimepointSubmissionStatus | null>(null)

  const contextValue: ExamReassignementContextType = {
    sourceStatus,
    setSourceStatus,
    destinationStatus,
    setDestinationStatus,
  }

  return <ExamReassignementContext.Provider value={contextValue}>{children}</ExamReassignementContext.Provider>
}
